import * as CryptoJS from 'crypto-js';

const EncryptionHelper = {
    // Same key and IV
    key: CryptoJS.enc.Utf8.parse('73980085041234569081836037373980'),
    iv: CryptoJS.enc.Utf8.parse('9081836037373980'),

    decrypt: function (encryptedText) {
        const decrypted = CryptoJS.AES.decrypt(encryptedText, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

        // If numeric, convert (optional)
        if (!isNaN(Number(decryptedString))) {
            return Number(decryptedString);
        }

        return decryptedString;
    }
};

export default EncryptionHelper;